export const LangEn = {
    name:'en',
    data:{
        "modalExp":{
            "name":"kd,mkdmdké"
        },
        "name":'Ceci est un test',
        "pdf_view":{
            "not_found":"This document cannot be found. It may not have been uploaded, or it has been deleted.",
            "error":"The document could not be loaded. Please try again in a few moments.",
            "retry":"Try again"
        },
        "residencePermit":{
            "title":"Residence permit",
            "valid_until":"Valid until {date}",
            "expires_on":"Expires on {date}",
            "expired_on":"Expired on {date}",
            "end_unknown":"End date not provided",
            "document_types":{
                "new_permit":"New residence permit",
                "receipt":"Renewal receipt",
                "anef_extension":"Application extension certificate (ANEF)"
            },
            "document_status":{
                "pending":"Under review",
                "validated_until":"Approved until {date}",
                "validated":"Approved",
                "refused_with_reason":"Refused: {reason}",
                "refused":"Refused"
            },
            "add_extension":"Add my extension",
            "banner_expiring_title":"Your residence permit expires soon",
            "banner_expiring_text":"Add its extension to keep receiving missions.",
            "banner_expired_title":"Residence permit expired",
            "banner_expired_text":"Add its extension: no mission can be assigned to you in the meantime.",
            "extension_modal":{
                "choice_title":"Residence permit extension",
                "choice_subtitle":"Which document did you receive?",
                "choice_consent":"By selecting a document, you allow our partners to verify your identity and accept our privacy policy.",
                "options":{
                    "new_permit":{
                        "title":"New residence permit",
                        "subtitle":"Renewed residence card or visa, front and back",
                        "import_button":"Upload the residence permit"
                    },
                    "receipt":{
                        "title":"Renewal receipt",
                        "subtitle":"Issued by the prefecture while your application is being reviewed",
                        "import_button":"Upload the receipt"
                    },
                    "anef_extension":{
                        "title":"Application extension certificate",
                        "subtitle":"Downloaded from the ANEF website",
                        "import_button":"Upload the certificate"
                    }
                },
                "conditions_intro":"Make sure the document meets these conditions:",
                "conditions":{
                    "readable_title":"Readable",
                    "readable_text":"No blur or glare: every detail can be read.",
                    "whole_title":"The whole document is visible",
                    "whole_text":"All four corners show, nothing is cut off or hidden.",
                    "end_date_title":"End date readable",
                    "end_date_text":"The date until which it is valid appears."
                },
                "file_front":"Front",
                "file_back":"Back",
                "file_single":"Document",
                "back":"Back",
                "analysing":"Analysing the document…",
                "date_title":"Check the end date",
                "date_text":"We read it on your document. Correct it if needed: it determines which missions can be offered to you.",
                "date_label":"Valid until",
                "date_placeholder":"DD/MM/YYYY",
                "date_unread":"We could not read the date: please enter it.",
                "confirm":"Confirm and send",
                "cancel":"Cancel",
                "success":"Your document has been sent: it is under review.",
                "errors":{
                    "VISA_COMPLEMENTARY_PENDING":"A document is already under review: wait for its outcome before adding another one.",
                    "RESIDENCE_PERMIT_MISSING":"Add your residence permit first, before its extension.",
                    "VISA_COMPLEMENTARY_FILE_MISSING":"A file is missing: upload each requested side.",
                    "END_VALIDITY_IN_PAST":"This date has already passed: enter the end date shown on the document.",
                    "INVALID_END_VALIDITY":"This date is not valid: please enter it again.",
                    "VISA_COMPLEMENTARY_NOT_DRAFT":"This document has already been sent. Close this window to see its status.",
                    "default":"An error occurred. Please try again in a few moments."
                }
            }
        },
        "mission":{
            "tasks_title":"Tasks of the ",
            "tasks_title_elided":"Tasks of the "
        },
        map : new Map()
    }
}